import Vue from 'vue'
import './plugins/axios'
import './plugins/vant'
import App from './App.vue'
import router from './router'
import "@/style/global.css"
import store from './store'
import i18n from './i18n'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
